import { useEffect, useMemo, useState } from 'react'
import { customersApi, salesApi, sellersApi } from '../../services/api'
import LocationsMaps from '../../components/LocationsMaps'

export default function RoutesPage() {
  const [customers, setCustomers] = useState<any[]>([])
  const [sales, setSales] = useState<any[]>([])
  const [sellers, setSellers] = useState<any[]>([])
  const [filterSellerId, setFilterSellerId] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [customersRes, salesRes, sellersRes] = await Promise.all([
          customersApi.list(),
          salesApi.list(),
          sellersApi.list(),
        ])
        setCustomers(customersRes.data.customers || [])
        setSales(salesRes.data.sales || [])
        setSellers(sellersRes.data.sellers || [])
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  const filteredCustomers = useMemo(
    () => (filterSellerId ? customers.filter((c) => String(c.seller_id) === filterSellerId) : customers),
    [customers, filterSellerId]
  )
  const filteredSales = useMemo(
    () => (filterSellerId ? sales.filter((s) => String(s.seller_id) === filterSellerId) : sales),
    [sales, filterSellerId]
  )

  if (loading) {
    return <div className="text-center py-8">Cargando...</div>
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-espresso-800">Mapa de Ubicaciones</h1>
        <div className="flex items-center gap-2">
          <label htmlFor="routes-seller-filter" className="text-sm text-espresso-600">
            Vendedor:
          </label>
          <select
            id="routes-seller-filter"
            value={filterSellerId}
            onChange={(e) => setFilterSellerId(e.target.value)}
            className="border border-espresso-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500"
          >
            <option value="">Todos los vendedores</option>
            {sellers.map((s) => (
              <option key={s.id} value={s.id}>
                {s.full_name}{s.status !== 'active' ? ' (inactivo)' : ''}
              </option>
            ))}
          </select>
        </div>
      </div>

      <LocationsMaps customers={filteredCustomers} sales={filteredSales} />
    </div>
  )
}
